
import React from 'react';
import { NumberedCollapsibleSection } from './';
import { Button } from '@/components/ui/button';
import { useFormSectionButton } from '@/hooks/useFormSectionButton';

interface FormSectionProps {
  number: number;
  title: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  isCompleted: boolean;
  isDisabled: boolean;
  isComplete: boolean;
  isEdited: boolean;
  hasUnsavedChanges?: boolean;
  onSave: () => void;
  isProcessing?: boolean;
  children: React.ReactNode;
}

const FormSection: React.FC<FormSectionProps> = ({
  number,
  title,
  open,
  onOpenChange,
  isCompleted,
  isDisabled,
  isComplete,
  isEdited,
  hasUnsavedChanges = false,
  onSave,
  isProcessing = false,
  children
}) => {
  const { showButton, buttonText, buttonEnabled } = useFormSectionButton({
    isComplete,
    isEdited,
    hasUnsavedChanges
  });

  return (
    <NumberedCollapsibleSection
      number={number}
      title={title}
      open={open}
      onOpenChange={onOpenChange}
      isCompleted={isCompleted}
      isDisabled={isDisabled}
    >
      <div>
        {children}
        {showButton && (
          <div className="mt-6">
            <Button
              onClick={onSave}
              disabled={!buttonEnabled || isProcessing}
              className="w-full"
            >
              {isProcessing ? "Processing..." : buttonText}
            </Button>
          </div>
        )}
      </div>
    </NumberedCollapsibleSection>
  );
};

export default FormSection;
